import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ProductService } from '../services/product.service';
import { IProduct } from '../interfaces/product';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppSettings } from '../appSettings';

import { CategoryService } from '../services/category.service';

import { ICategory } from '../interfaces/category';
import { ISubcategory } from '../interfaces/subcategory';

import { SubcategoriaItemComponent } from '../components/subcategoria-item/subcategoria-item.component';

import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { ApiService } from '../services/api.service';

import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';
import { AppFormat } from '../appFormat';
import { IOption } from '../interfaces/option';
import { ProductOffersComponent } from '../components/product-offers/product-offers.component';

import {
  faChevronLeft,
  faEllipsisV,
  faPlus,
  faTimes,
  faExternalLinkSquareAlt,
  faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
import { OperadorService } from '../services/operador.service';
import { IImage } from '../interfaces/image';

declare var Quagga: any;

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
  host: { class: 'wrapper-product-detail' },
  encapsulation: ViewEncapsulation.None,
})
export class ProductDetailComponent implements OnInit, AfterViewInit {
  @Output() onChangeEvent = new EventEmitter<IProduct>();
  @Output() onCloseEvent = new EventEmitter<any>();

  @ViewChild(SubcategoriaItemComponent)
  subcategoriaItem: SubcategoriaItemComponent;

  @ViewChild(ProductOffersComponent) productOffersItem: ProductOffersComponent;

  public faChevronLeft = faChevronLeft;
  public faEllipsisV = faEllipsisV;
  public faPlus = faPlus;
  public faTimes = faTimes;
  public faExternalLinkAlt = faExternalLinkAlt;

  public loading: boolean = false;
  public loadingProduct: boolean = false;
  public changeDetail: boolean = false;
  public isAdmin: boolean = false;
  public isReadCodbar: boolean = false;
  public isView: boolean = false;
  public openReaderBarcode: boolean = false;
  public worksReaderBarcode: boolean = false;

  public isEditImages: boolean = false;

  public categorias: ICategory[] = [];
  public subcategorias: ISubcategory[] = [];
  public unidades = [
    { label: 'L', unidade: 'l' },
    { label: 'ml', unidade: 'ml' },
    { label: 'Kg', unidade: 'kg' },
    { label: 'g', unidade: 'g' },
  ];

  public codbarra: string;
  public gallery: IImage[] = [];
  public image_sel_src: string = '';
  public numberPhoto: number = 0;

  public categories: FormArray;
  public changeDepartamentos: boolean = false;

  public product: IProduct;

  public produtoFrm: FormGroup;

  public preco: FormControl;

  public estoque: FormControl;
  private estoque_bk;

  public descricao: FormControl;
  public subtitulo: FormControl;
  public marca: FormControl;

  public image_subtitle: string;

  public max_pr_cliente: FormControl;
  public sem_limite: FormControl;
  public limite_minimo_estoque: FormControl;

  public peso_liquido: FormControl;
  public unidade_peso_liquido: FormControl;

  public refrigerado: FormControl;
  public ckAmadurecimento: FormControl;

  public ckChangePrice: FormControl;
  public ckFrete: FormControl;
  public ckStatus = true;

  public tab: string = 'price';

  public optionOpen: boolean = false;
  public optionTimeout: any = null;

  public urlproduct: string = '';

  private subscription: Subscription;
  private url_estabelecimento: string = '';

  public URL_IMG_PRODUTO: string = AppSettings.URL_IMG_PRODUTO;
  public uploader: FileUploader;
  public hasBaseDropZoneOver: boolean = false;

  public fileView: any = null;
  public fileViewIdx: any = null;
  public fileImageIdx: any = null;
  public isFileView: boolean = false;
  public isImageView: boolean = false;
  public isImageChange: boolean = false;
  public changeImage: boolean = false;
  public image_sel_hash: string = '';

  constructor(
    private _productService: ProductService,
    private _operadorService: OperadorService,
    private _categoryService: CategoryService,
    private _apiService: ApiService
  ) {
    this.initProduct();

    this._categoryService.getAll().subscribe((res) => {
      this.categorias = res.categorias;
    });

    this.subscription = this._operadorService.url_estabelecimento.subscribe(
      (res) => {
        this.url_estabelecimento = res;
      }
    );

    /**
     *
     * envio das fotos
     *
     */

    this.uploader = new FileUploader({
      url: this._apiService.API_PATH,
      queueLimit: 5,
      allowedFileType: ['image'],
      allowedMimeType: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
      maxFileSize: 1048576 * 2,
      filters: [
        {
          name: 'imageFilter',
          fn: function (item /*{File|FileLikeObject}*/, options) {
            var type =
              '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
          },
        },
      ],
    });

    this.uploader.onAfterAddingFile = (f) => {
      f.withCredentials = false;

      if (this.changeImage) {
        this.saving();
        this.sendImages();
      } else {
        this.onChangeDetail();

        setTimeout(() => {
          let idx = this.uploader.queue.length - 1;
          this.selectImageView(this.uploader.queue[idx], idx);
        }, 600);
      }
    };

    this.uploader.onBeforeUploadItem = (fileItem: any) => {
      if (this.changeImage) {
        let number = 1;
        if (this.gallery[this.fileImageIdx]['padrao'] == 'E') {
          number = this.gallery[this.fileImageIdx].number;
        } else {
          //se o item a substituir for padrao ele procura se existe algum E
          number = 0;
          for (let i in this.gallery) {
            if (this.gallery[i]['padrao'] == 'E') {
              //pega o ultimo numero E.. e acrescenta um valor
              if (number <= this.gallery[i].number) {
                number = parseInt(this.gallery[i].number.toString());
              }
            }
          }
          number = number + 1;
        }
        fileItem.options.additionalParameter = {
          number: number,
          idproduto_geral: this.product.idproduto_geral,
          change: true,
        };
      } else {
        //this.numberPhoto = this.numberPhoto + 1

        let number = 0;
        for (let i in this.gallery) {
          if (this.gallery[i]['padrao'] == 'E') {
            //pega o ultimo numero E.. e acrescenta um valor
            if (number <= this.gallery[i].number) {
              number = parseInt(this.gallery[i].number.toString());
            }
          }
        }
        number = number + 1;

        fileItem.options.additionalParameter = {
          number: number,
          idproduto_geral: this.product.idproduto_geral,
          legenda: fileItem.formData[0]['legenda'],
        };
      }
    };

    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          if (this.changeImage) {
            //responsePath['url']

            this.gallery[this.fileImageIdx] = responsePath['url'];
            this.gallery[this.fileImageIdx].hash = AppFormat.makeid(5);
            this.image_sel_hash = AppFormat.makeid(5);
            this.changeImage = false;
          } else {
            //console.log(AppSettings.URL_IMG_PROJECTS+this.idproject+'/'+responsePath['name'])
            this.gallery.push(responsePath['url']);
          }
        }
      }

      //this.numberPhoto = this.numberPhoto + 1
    };

    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();
      this.numberPhoto = this.gallery.length;
      this.saveComplete();
    };

    this.uploader.onErrorItem = (
      item: FileItem,
      response: any,
      status: any,
      headers: any
    ) => {
      //console.log(item)

      item.remove();

      Swal.fire(
        'Ops!',
        'Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho',
        'error'
      );
    };

    this.uploader.onWhenAddingFileFailed = function (
      item: FileLikeObject,
      filter: any,
      options: any
    ) {
      //console.log(item);
      //console.log(filter);
      //console.log(options);

      Swal.fire(
        'Ops!',
        'O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!',
        'error'
      );
    };
  }

  ngOnInit(): void {
    let operador = this._operadorService.getOperador();
    this.isAdmin = operador.sc_tipo == 'A';

    this.createFormControls();
    this.createForm();

    this.loading = true;
  }

  ngAfterViewInit() {
    this.initCodbar();
  }

  createFormControls() {
    this.preco = new FormControl('', [Validators.required]);
    this.estoque = new FormControl(null);

    this.ckAmadurecimento = new FormControl(false);
    this.sem_limite = new FormControl(false);
    this.limite_minimo_estoque = new FormControl(null);
    this.max_pr_cliente = new FormControl(null);
    this.ckChangePrice = new FormControl(null);
    this.ckFrete = new FormControl(null);
    // this.ckStatus = new FormControl(false);

    this.descricao = new FormControl('');
    this.subtitulo = new FormControl('');

    this.categories = new FormArray([]);
    this.addNewCategory();

    //
    this.marca = new FormControl('');
    this.peso_liquido = new FormControl('');
    this.unidade_peso_liquido = new FormControl('g');

    this.refrigerado = new FormControl('');
  }

  createForm() {
    this.produtoFrm = new FormGroup({
      preco: this.preco,
      estoque: this.estoque,
      ckAmadurecimento: this.ckAmadurecimento,
      max_pr_cliente: this.max_pr_cliente,
      marca: this.marca,
      peso_liquido: this.peso_liquido,
      unidade_peso_liquido: this.unidade_peso_liquido,
      categories: this.categories,
      sem_limite: this.sem_limite,
      limite_minimo_estoque: this.limite_minimo_estoque,
      descricao: this.descricao,
      subtitulo: this.subtitulo,
      refrigerado: this.refrigerado,
      ckFrete: this.ckFrete,
      ckChangePrice: this.ckChangePrice,
      // ckStatus: this.ckStatus,
    });
  }

  initProduct(): void {
    this.product = {
      idproduto_estabelecimento: 0,
      idproduto_geral: 0,
      descricao: '',
      marca: '',
      embalagem: '',
      peso_liquido: 0,
      unidade_peso_liquido: '',
    };
    this.image_sel_src = '';
    this.changeDepartamentos = false;
    this.estoque_bk = null;
    this.changeDetail = false;
  }

  toggleOptions(): void {
    this.optionOpen = !this.optionOpen;

    this.clearOptions();
  }

  hideOptions(): void {
    if (this.optionOpen) {
      if (this.optionTimeout) clearTimeout(this.optionTimeout);

      this.optionTimeout = setTimeout(() => {
        this.optionOpen = false;
      }, 2000);
    }
  }

  clearOptions(): void {
    if (this.optionTimeout) clearTimeout(this.optionTimeout);
  }

  public onClose() {
    if (this.onCloseEvent) this.onCloseEvent.emit(true);
  }

  public newCategory(frm: FormGroup) {
    frm.controls.categoria.setValue(null);
    let status = frm.controls.showText.value;
    frm.controls.showText.setValue(!status);
  }

  public addNewCategory() {
    this.categories.push(
      new FormGroup({
        categoria: new FormControl(null),
        list: new FormControl([]),
        showText: new FormControl(false),
        subcategorias: new FormArray([]),
      })
    );
  }

  public removeCategoria(i: number) {
    Swal.fire({
      title: 'Você deseja remover a categoria do produto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value && this.categories.controls.length > 1) {
        this.categories.controls.splice(i, 1);
        this.onChangeDepartamento();
      }
    });
  }

  public addNewSubcategory(frm: FormArray) {
    frm.push(
      new FormGroup({
        subcategoria: new FormControl(null),
        list: new FormControl([]),
        showText: new FormControl(false),
        subcategorias: new FormArray([]),
      })
    );
  }

  public removeSubcategoria(frm: FormArray, j) {
    Swal.fire({
      title: 'Você deseja remover a subcategoria do produto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value && frm.controls.length > 1) {
        frm.controls.splice(j, 1);
        this.onChangeDepartamento();
      }
    });
  }

  public resetSubcategoria(categoria: FormGroup) {
    categoria.controls.subcategorias = new FormArray([]);
  }

  onChangeCategoria(
    categoria: FormGroup,
    i: number = 0,
    add: boolean = true
  ): void {
    this.resetSubcategoria(categoria);
    this._categoryService
      .getSubcategoriesFrom(categoria.controls.categoria.value)
      .subscribe((res) => {
        categoria.controls.list.setValue(res.subcategorias);
        this.onChangeDepartamento();

        if (res.subcategorias.length > 0 && add) {
          this.addNewSubcategory(<FormArray>categoria.controls.subcategorias);
        }
        setTimeout(() => {
          this.subcategoriaItem.realoadSubcategoria(i);
        }, 1000);
      });
  }

  ajustUrl(url) {
    return url.replace(
      AppSettings.URL_IMG_PRODUTO,
      AppSettings.URL_S3_IMG_PRODUTO
    );
  }

  onInitCam(): void {
    // console.log(Quagga);

    var self = this;

    Quagga.init(
      {
        inputStream: {
          name: 'Live',
          type: 'LiveStream',
          target: document.querySelector('#readBarcode'),
        },
        decoder: {
          readers: ['ean_reader'],
        },
        locate: true,
      },
      function (err) {
        if (err) {
          console.log(err);
          return;
        }
        self.worksReaderBarcode = true;
        // console.log('Initialization finished. Ready to start');
        Quagga.start();
      }
    );
  }

  private initCodbar(): void {
    var self = this;

    if (Quagga)
      Quagga.onProcessed(function (res) {
        if (res && res.codeResult) {
          // console.log(res);
          self.getProductCodbar(res.codeResult.code);
          self.onCloseReadBarcode();
        }
      });
  }

  onOpenBarcode(): void {
    this.onInitCam();

    this.openReaderBarcode = true;
  }

  onCloseReadBarcode(): void {
    this.openReaderBarcode = false;
    if (this.worksReaderBarcode && Quagga) Quagga.stop();
  }

  onUnlimitedStock(): void {
    if (this.estoque_bk != null) {
      this.estoque.setValue(this.estoque_bk);
      this.estoque_bk = null;
    } else {
      this.estoque_bk = this.estoque.value;
      this.estoque.setValue(null);
    }
    this.onChangeDetail();
  }

  onKeyCodbarra(ev): void {
    let cod = ev.target.value;
    if (cod && cod.length == 23 && this.loadingProduct == false) {
      this.onSearchProduct();
    }
  }

  onTabClick(t) {
    this.tab = t;
  }

  onCancelRegister() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        if (this.product.idproduto_geral > 0) {
          this.getProductID(this.product.idproduto_geral);
        } else {
          this.newProduct(this.codbarra);
        }
      }
    });
  }

  onChangePrice() {
    // this.productOffersItem.setNormalPrice(this.preco.value);
    this.onChangeDetail();
  }

  onChangeDetail() {
    this.changeDetail = true;
  }

  onChangeDepartamento() {
    this.changeDepartamentos = true;
    this.onChangeDetail();
  }

  onSearchProduct(): void {
    let cod = (<HTMLInputElement>(
      document.getElementById('codbarra')
    )).value.replace(/\D/g, '');

    if (cod != '' && cod != null && cod != undefined) {
      this.codbarra = cod;
      this.getProductCodbar(cod);
    }
  }

  openEditImages(): void {
    this.isEditImages = true;
  }

  closeEditImages(): void {
    this.isEditImages = false;
  }

  convertUnidade(u): string {
    if (u == '' || u == null || u == undefined) return '';
    let pg_unidade_peso_liquido = '';
    switch (u.toLowerCase()) {
      case 'g':
      case 'grama(s)':
      case 'gramas':
        pg_unidade_peso_liquido = 'g';
        break;
      case 'kg':
      case 'k':
      case 'guilograma(s)':
      case 'guilogramas':
        pg_unidade_peso_liquido = 'kg';
        break;
      case 'l':
      case 'litro(s)':
      case 'litros':
        pg_unidade_peso_liquido = 'l';
        break;
      case 'ml':
      case 'mililitro(s)':
      case 'mililitros':
        pg_unidade_peso_liquido = 'ml';
        break;
    }
    return pg_unidade_peso_liquido;
  }

  openNewProduct(): void {
    this.initProduct();
    this.isReadCodbar = true;
    this.onTabClick('attr');
    this.loadingProduct = false;
  }

  newProduct(cod): void {
    this.initProduct();
    this.produtoFrm.reset();

    this.categories.clear();
    this.addNewCategory();

    this.productOffersItem.clear();
    this.productOffersItem.setSimpleStyle();

    this.isReadCodbar = false;

    this.product['is_owner'] = true;
    this.product['flag_foto'] = 'E';
    this.gallery = [];

    this.codbarra = cod;

    this.isView = false;

    this.loading = false;
    this.loadingProduct = false;
  }

  getProductID(cod: number): void {
    this.loadingProduct = true;
    this.isReadCodbar = false;
    this.isView = false;

    this.initProduct();

    this.onTabClick('price');

    this._productService.getProductID(cod).subscribe((res) => {
      this.resProduct(res, cod);
    });
  }

  getProductCodbar(cod: string): void {
    this.loadingProduct = true;
    this.isReadCodbar = false;
    this.isView = false;

    this.initProduct();

    this._productService.getProductCodbar(cod).subscribe((res) => {
      this.resProduct(res, cod);
    });
  }

  getTreeSubcategoria(arr) {
    //this.product.categories[i].subcategories
    let ret = [];

    for (let j in arr) {
      let arr_sub =
        arr[j]['subcategorias'] && arr[j]['subcategorias'].length > 0
          ? this.getTreeSubcategoria(arr[j]['subcategorias'])
          : [];

      ret.push(
        new FormGroup({
          subcategoria: new FormControl(arr[j].idsubcategoria),
          showText: new FormControl(false),
          list: new FormControl([]),
          subcategorias: new FormArray(arr_sub),
        })
      );
    }

    return ret;
  }

  loadCategoria(arr) {
    this.categories.clear();
    this.changeDepartamentos = false;

    for (let i in arr) {
      let arr_sub =
        arr[i].subcategorias && arr[i].subcategorias.length > 0
          ? this.getTreeSubcategoria(arr[i].subcategorias)
          : [];

      let frmCategoria = new FormGroup({
        categoria: new FormControl(arr[i].idcategoria),
        list: new FormControl([]),
        subcategorias: new FormArray(arr_sub),
        showText: new FormControl(false),
      });

      this._categoryService
        .getSubcategoriesFrom(arr[i].idcategoria)
        .subscribe((res) => {
          if (res.subcategorias) {
            frmCategoria.controls.list.setValue(res.subcategorias);
          }
        });

      this.categories.push(frmCategoria);
    }
  }

  resProduct(res, cod) {
    this.productOffersItem.setSimpleStyle();
    this.productOffersItem.clear();
    this.urlproduct = '';

    if (res['success'] == true) {
      this.product = res;

      this.urlproduct =
        this.url_estabelecimento +
        AppFormat.gSlug(this.product.descricao) +
        '/' +
        this.product.codbarra +
        '/d';

      //carrega as ofertas se tiver do produto
      this.productOffersItem.loadData(this.product.idproduto_estabelecimento);
      this.productOffersItem.setNormalPrice(this.product.preco);

      //edit all
      this.preco.setValue(this.product.preco);

      this.estoque_bk = null;

      if (this.product.estoque > 0) {
        this.estoque.setValue(this.product.estoque);
      } else {
        this.estoque.setValue(null);
      }

      this.sem_limite.setValue(this.product.estoque_infinito == 'S');

      if (this.product.limite_minimo_estoque >= 0) {
        this.limite_minimo_estoque.setValue(this.product.limite_minimo_estoque);
      } else {
        this.limite_minimo_estoque.setValue(null);
      }

      if (this.product.max_pr_cliente >= 0) {
        this.max_pr_cliente.setValue(this.product.max_pr_cliente);
      } else {
        this.max_pr_cliente.setValue(null);
      }

      this.codbarra = this.product.codbarra;

      this.ckStatus = this.product.status == 'A';
      this.ckAmadurecimento.setValue(
        this.product.flag_amadurecimento == 'S' ? true : false
      );

      // edit only owner
      // this.importado.setValue(this.product.importado == 'S' ? true : false);
      // this.fabricacao.setValue(this.product.fabricacao);

      this.descricao.setValue(this.product.descricao);

      // this.detalhe.setValue(this.product.detalhe);

      // this.keywords.setValue(this.product.keywords);

      this.loadCategoria(this.product.categories);

      // this.codigo_interno.setValue(this.product.codigo_interno);

      this.marca.setValue(this.product.marca);
      // this.embalagem.setValue(this.product.embalagem);

      // this.forma_venda.setValue(this.product.forma_venda);
      // this.forma_venda_mostra.setValue(this.product.forma_venda_mostra);

      // this.vivino_code.setValue(this.product.vivino_code);
      // this.vivino_safra.setValue(this.product.vivino_safra);

      this.subtitulo.setValue(this.product.subtitulo);

      // this.relevancia.setValue(this.product.relevancia);

      this.refrigerado.setValue(this.product.refrigerado == 'S' ? true : false);

      this.ckFrete.setValue(this.product.frete_gratis == 'S' ? true : false);
      this.ckChangePrice.setValue(
        this.product.mudar_preco == 'S' ? true : false
      );

      this.peso_liquido.setValue(this.product.peso_liquido);
      this.unidade_peso_liquido.setValue(
        this.convertUnidade(this.product.unidade_peso_liquido)
      );

      // if (this.product.detalhe != '') {
      // this.describeVisible = true;
      // }

      // if (
      //   this.product.estoque <= this.lower_stock &&
      //   this.product.estoque > 0
      // ) {
      //   this.hasLowerStoke = true;
      // }
      // if (this.product.estoque == 0) {
      //   this.hasOutOfStock = true;
      // }

      this.gallery = this.product.images;

      if (this.gallery && this.gallery.length > 0) {
        this.numberPhoto = this.gallery.length;
        for (let i in this.gallery) this.gallery[i].hash = AppFormat.makeid(3);
        this.selectPhoto(this.gallery[0], 0);
      }

      this.isView = this.product.is_owner != true;

      this.loading = false;
      this.loadingProduct = false;
    } else {
      setTimeout(() => {
        this.newProduct(cod);
      }, 1000);
    }
  }

  selectImageView(file, idx): void {
    this.fileViewIdx = idx;
    this.fileImageIdx = null;
    this.fileView = file;
    this.isFileView = true;
    this.isImageView = false;

    if (!this.fileView.formData[0]) {
      this.fileView.formData.push({ legenda: '' });
    }

    this.image_subtitle = this.fileView.formData[0]['legenda']
      ? this.fileView.formData[0]['legenda']
      : '';
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  addMoreImage(): void {
    this.changeImage = false;
    this.isFileView = false;
    this.isImageView = false;
    this.fileView = this.fileViewIdx = this.fileImageIdx = null;
    this.image_subtitle = '';
  }

  onRemoveImage(): void {
    Swal.fire({
      title: 'Você deseja excluir a imagem?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Excluindo...',
          icon: 'info',
          showCancelButton: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
        });

        if (
          this.gallery[this.fileImageIdx]['padrao'] &&
          this.gallery[this.fileImageIdx]['padrao'] == 'P'
        ) {
          Swal.fire({
            title: 'Excluida!',
            icon: 'success',
            text: 'A imagem foi excluida',
            showCancelButton: false,
            allowOutsideClick: true,
            showConfirmButton: true,
            heightAuto: false,
          });

          for (let i in this.gallery) {
            this.gallery[i].hash = AppFormat.makeid(5);
          }
          this.image_sel_hash = AppFormat.makeid(5);

          this.numberPhoto = this.numberPhoto - 1;

          this.gallery.splice(this.fileImageIdx, 1);

          this.addMoreImage();

          this.onChangeDetail();
        } else {
          this._productService
            .removeImage(
              this.product.codbarra,
              this.gallery[this.fileImageIdx].number,
              this.product.idproduto_geral,
              this.gallery[this.fileImageIdx]['idestabelecimento']
            )
            .subscribe((res) => {
              Swal.fire({
                title: 'Excluida!',
                icon: 'success',
                text: 'A imagem foi excluida',
                showCancelButton: false,
                allowOutsideClick: true,
                showConfirmButton: true,
                heightAuto: false,
              });

              this.gallery.splice(this.fileImageIdx, 1);

              let c = 1;
              for (let i in this.gallery) {
                if (
                  this.gallery[i]['padrao'] &&
                  this.gallery[i]['padrao'] == 'E'
                ) {
                  this.gallery[i].number = c;
                  ++c;
                }
                this.gallery[i].hash = AppFormat.makeid(5);
              }
              this.image_sel_hash = AppFormat.makeid(5);

              this.numberPhoto = this.numberPhoto - 1;

              this.addMoreImage();

              this.onChangeDetail();
            });
        }
      }
    });
  }

  onChangeSubtitle(): void {
    if (this.fileImageIdx == null) {
      //new file
      this.fileView.formData[0]['legenda'] = this.image_subtitle;
    } else {
      this.gallery[this.fileImageIdx]['legenda'] = this.image_subtitle;
    }
    this.onChangeDetail();
  }

  onRemoveFileImage(): void {
    Swal.fire({
      title: 'Você deseja excluir a imagem?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        this.fileView.remove();
        this.addMoreImage();
      }
    });
  }

  onChangeImage(): void {
    Swal.fire({
      title: 'Você deseja realizar a troca da imagem?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        this.changeImage = true;
        let el: HTMLElement = document.getElementById(
          'fileUploader'
        ) as HTMLElement;
        el.click();
      }
    });
  }

  selectPhoto(image: IImage, i: number) {
    this.image_sel_src = image.default;
    this.isImageView = true;
    this.isFileView = false;
    this.fileImageIdx = i;
    this.fileViewIdx = null;
    this.isImageChange =
      this.gallery[i]['idestabelecimento'] == this.product.idestabelecimento;

    this.image_subtitle = image.legenda ? image.legenda : '';
  }

  produtoValid() {
    let has = true;

    let msg = [];

    if (
      (this.preco.invalid && (this.preco.dirty || this.preco.touched)) ||
      this.preco.value == '' ||
      this.preco.value == undefined ||
      this.preco.value == null
    ) {
      msg.push('Você precisa preencher o valor do produto!');
      has = false;
    }

    /*
    if ((this.estoque.invalid && (this.estoque.dirty || this.estoque.touched)) || this.estoque.value == '' || this.estoque.value == undefined || this.estoque.value == null) {
      msg.push('Você precisa preencher a quantidade em estoque do produto!');
      has = false
    }
    */

    // if (
    //   (this.codbarra.invalid &&
    //     (this.codbarra.dirty || this.codbarra.touched)) ||
    //   this.codbarra.value == '' ||
    //   this.codbarra.value == undefined ||
    //   this.codbarra.value == null
    // ) {
    //   msg.push('Você precisa preencher o código de barra do produto!');
    //   has = false;
    // }

    for (let i in this.categories.controls) {
      let fGroup = <FormGroup>this.categories.controls[i];

      let categoria = <FormControl>fGroup.controls.categoria;
      if (
        (categoria.invalid && (categoria.dirty || categoria.touched)) ||
        categoria.value == '' ||
        categoria.value == null
      ) {
        msg.push('Você precisa selecionar a categoria!');
        has = false;
      }

      let subcategorias = <FormArray>fGroup.controls.subcategorias;
      for (let j in subcategorias.controls) {
        let fsGroup = <FormGroup>subcategorias.controls[j];

        let subcategoria = <FormControl>fsGroup.controls.subcategoria;
        if (
          (subcategoria.invalid &&
            (subcategoria.dirty || subcategoria.touched)) ||
          subcategoria.value == '' ||
          subcategoria.value == null
        ) {
          msg.push('Você precisa selecionar a subcategoria!');
          has = false;
        }
      }
    }

    if (msg.length > 0) {
      Swal.fire('Ops!', msg.join('<br>'), 'error');
    }

    return has;
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplete() {
    Swal.fire('Salvo!', 'O produto foi salvo', 'success');
  }

  saving() {
    Swal.fire({
      title: 'Salvando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  getListSubcategorias(frm: FormGroup) {
    let subcategorias = null;
    let subcategoria = frm.controls.subcategoria;
    if (
      subcategoria.value != '' &&
      subcategoria.value != null &&
      subcategoria.value != undefined
    ) {
      subcategorias = {
        idsubcategoria: subcategoria.value,
        subcategorias: [],
      };
      if (frm.controls.subcategorias) {
        let arr = <FormArray>frm.controls.subcategorias;
        for (let j in arr.controls) {
          let fsGroup = <FormGroup>arr.controls[j];

          let list = this.getListSubcategorias(fsGroup);
          if (list != null) {
            subcategorias['subcategorias'].push(list);
          }
        }
      }
    }
    return subcategorias;
  }

  onSubmit() {
    if (this.produtoValid()) {
      // if (this.forma_venda.value == 'U') {
      //   this.forma_venda_mostra.setValue('U');
      // }

      let data = {
        preco: this.preco.value,
        estoque: this.estoque.value,
        estoque_infinito: this.sem_limite.value ? 'S' : 'N',
        limite_minimo_estoque: this.limite_minimo_estoque.value,
        // keywords: this.keywords.value,
        max_pr_cliente: this.max_pr_cliente.value,
        // forma_venda: this.forma_venda.value,
        // forma_venda_mostra: this.forma_venda_mostra.value,
        // detalhe: this.detalhe.value,
        descricao: this.descricao.value,
        fotos: this.gallery,
        // vivino_code: this.vivino_code.value,
        // vivino_safra: this.vivino_safra.value,
        subtitulo: this.subtitulo.value,
        // relevancia: this.relevancia.value,
        // codigo_interno: this.codigo_interno.value,
        frete_gratis: this.ckFrete.value ? 'S' : 'N',
        status: this.ckStatus ? 'A' : 'I',
        flag_amadurecimento: this.ckAmadurecimento.value ? 'S' : 'N',
        mudar_preco: this.ckChangePrice.value ? 'S' : 'N',
        refrigerado: this.refrigerado.value ? 'S' : 'N',
      };

      if (this.product.idproduto_geral > 0) {
        data['idproduto_geral'] = this.product.idproduto_geral;
      }

      let categorias = [];
      for (let i in this.categories.controls) {
        let fGroup = <FormGroup>this.categories.controls[i];

        let categoria = <FormControl>fGroup.controls.categoria;

        let subcategorias = [];
        let subcategories = <FormArray>fGroup.controls.subcategorias;
        for (let j in subcategories.controls) {
          let fsGroup = <FormGroup>subcategories.controls[j];
          let list = this.getListSubcategorias(fsGroup);
          if (list) {
            subcategorias.push(list);
          }
        }
        if (subcategorias.length > 0) {
          categorias.push({
            idcategoria: categoria.value,
            subcategorias: subcategorias,
          });
        }
      }
      data['categorias'] = categorias;

      // if (!this.isView) {
      // other fields
      data['marca'] = this.marca.value;
      // data['embalagem'] = this.embalagem.value;
      data['peso_liquido'] = this.peso_liquido.value;
      data['unidade_peso_liquido'] = this.unidade_peso_liquido.value;

      if (this.product.idproduto_geral == 0) {
        data['codbarra'] = this.codbarra;
      }

      //   data['fabricacao'] = this.fabricacao.value;
      //   data['importado'] = this.importado.value ? 'S' : 'N';
      // }

      this.saving();

      //console.log(data)

      this.storeProduct(data);
    }
    return null;
  }

  storeProduct(data) {
    this._productService.store(data).subscribe(
      (res) => {
        if (res['success']) {
          if (this.product.idproduto_estabelecimento == 0) {
            this.product.idproduto_estabelecimento =
              res['idproduto_estabelecimento'];
            this.productOffersItem.loadData(
              this.product.idproduto_estabelecimento
            );
          }

          this.product['idproduto_geral'] = res['idproduto_geral'];
          // this._id = res['idproduto_geral'];

          if (this.changeDepartamentos) {
            this.loadCategoria(res['categories']);
          }

          /*
        if (!this.isView) {
          this.isView = true
        }
        */
          if (this.uploader.queue.length > 0) {
            this.product['flag_foto'] = 'E';
            this.sendImages();
          } else {
            if (this.onChangeEvent) this.onChangeEvent.emit(res);
            this.saveComplete();
          }
        } else {
          this.saveError();
        }
      },
      (error) => {
        this.saveError();
      }
    );
  }

  sendImages(): void {
    this.uploader.setOptions({
      url: this._apiService.API_PATH + 'product/' + this.codbarra + '/image',
      authTokenHeader: 'Authorization',
      authToken: 'Bearer ' + this._apiService.getAccessToken(),
    });
    this.uploader.uploadAll();
  }
}
